import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { technicalEnvironments } from '../data/technical';
import { conferences } from '../data/conferences';
export function TechnicalMastery() {
  return <section id="technology" className="bg-slate-50 py-24 lg:py-32" data-id="element-183" data-mp="2w7eh8iijyfro">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-184" data-mp="2r5fbx33958s3">
        <SectionHeading eyebrow="08 — Technical Mastery" title="Systems Portfolio &amp; Industry Keynotes" data-id="element-185" data-mp="2n4dcom9c4wq4" />

        <div className="mt-14" data-id="element-186" data-mp="2id51plscx3au">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-187" data-mp="2ibtz3pane1lb">
            Technical Environments
          </span>
          <div className="mt-5 flex flex-wrap gap-3" data-id="element-188" data-mp="28gii10broiae">
            {technicalEnvironments.map(env => <span key={env.label} className="border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-slate-700" data-id="element-189" data-mp="23fl0mpykzs9y">
                {env.label}
              </span>)}
          </div>
        </div>

        <div className="mt-14 border-t border-slate-200 pt-14" data-id="element-190" data-mp="3fjdjdspgmjn4">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-191" data-mp="3fkyf3lnig8mk">
            Industry Keynotes
          </span>
          <p className="mt-4 text-sm leading-relaxed text-slate-600 max-w-2xl" data-id="element-192" data-mp="35tkipmquvoxn">
            Speaker and contributor at leading international executive forums shaping the future of enterprise
            growth and digital transformation.
          </p>
          <div className="mt-8 grid sm:grid-cols-3 gap-6" data-id="element-193" data-mp="2cc55f35vb8q">
            {conferences.map((conf, index) => <motion.div key={conf.name} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1],
            delay: index * 0.08
          }} className="border border-slate-300 bg-white px-8 py-10 text-center hover:border-gold transition-colors duration-200" data-id="element-194" data-mp="3kkt5lo3diw73" data-mpi={index}>
                <span className="font-serif text-2xl font-semibold text-navy tracking-tight" data-id="element-195" data-mp="eoe6evm1ensg">{conf.name}</span>
                <span className="mt-2 block text-xs uppercase tracking-[0.15em] text-slate-500" data-id="element-196" data-mp="9vbltcz8mooe">{conf.detail}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}